export default "__VITE_ASSET__66bb331e__"